<template>
  <div class="layout">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/>
  </div>
</template>

<script>
export default {
  name: 'Main'
};
</script>

<style scoped lang="stylus">
@import '~@/assets/styles/var.styl'
.layout {
  background-color $backgroundColorLight
  min-height 100%
}
</style>
